export default __webpack_public_path__ + "static/media/MehmetAsker.eb7cc5bd.png";